<template>
    <div v-if="showModal" id="center_detail_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">센터</h3>
            </div>
            <div id="body" class="ui segment">
                <form class="ui form">
                    <div class="two fields">
                        <div class="required field">
                            <label class="ui left aligned header">이름</label>
                            <input type="text" name="name" placeholder="이름을 입력하세요" v-model="name" autocomplete=off>
                            <p class="ui pointing blow orange basic label" v-if="$validator.hasError('name')">{{ $validator.getError('name') }}</p>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">비밀번호</label>
                            <input type="text" name="password" v-model="password" autocomplete=off>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">전화번호</label>
                            <input type="text" name="phone" placeholder="000-0000-0000" v-model="phone" autocomplete=off>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">설명</label>
                            <input type="text" name="description" placeholder="설명을 입력하세요" v-model="description" autocomplete=off>
                        </div>
                    </div>
                    <div class="required field">
                        <label class="ui left aligned header">지역</label>
                        <div class="ui clearable multiple selection dropdown">
                            <input type="hidden" name="region" @change="onRegionChange()">
                            <i class="dropdown icon"></i>
                            <div class="default text">선택</div>
                            <div class="menu">
                                <div class="item" v-for="(region1, i) in region1Options" :key="i">{{ region1 }}</div>
                            </div>
                        </div>
                        <p class="ui pointing blow orange basic label" v-if="$validator.hasError('region')">{{ $validator.getError('region') }}</p>
                    </div>
                </form>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui red left labeled icon button" @click="deleteCenter">
                    <i class="checkmark icon"></i>삭제
                </div>
                <div v-if="!center && $validator.isAllValidate()" class="ui primary left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>등록
                </div>
                <div v-if="center && $validator.isAllValidate()" class="ui orange left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>저장
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, center: 0, name: 0, phone: 0, description: 0, regions: 0, password: "", onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.center = this.name = this.phone = this.description = this.regions = 0;
    },
    mounted: function() {
        this.$event.set("registerCenter", this.registerCenter);
        this.$event.set("editCenter", this.editCenter);
    },
    beforeDestroyed: function() {
        this.$event.clear("registerCenter");
        this.$event.clear("editCenter");
    },
    methods: {
        registerCenter(onChange) {
            this.center = null;
            this.name = "";
            this.phone = "";
            this.description = "";
            this.password = "0000";
            this.regions = {};
            this.onChange = onChange;
            this.open();
        },
        editCenter(center, onChange) {
            this.center = center;
            this.name = center.name;
            this.phone = center.phone;
            this.description = center.description;
            this.password = center.password;
            this.regions = (center.regions) ? JSON.parse(JSON.stringify(center.regions)) : {};
            this.onChange = onChange;
            this.open();
        },
        open() {
            this.showModal = true;
            this.checkValidate();
            this.$nextTick(() => {
                if (this.center) {
                    let regionNames = Object.keys(this.regions);
                    $("input[name=region]").attr("value", (regionNames.length > 0) ? regionNames.join() : "");
                } else {
                    $("input[name=region]").attr("value", "");
                }
                $('.ui.dropdown').dropdown();
            });
        },
        close() {
            this.showModal = false;
        },
        getCenter()
        {
            return {
                name: this.name,
                password: this.password,
                phone: this.phone,
                description: this.description,
                regions: this.regions,
            };
        },
        save() {
            if (this.checkValidate()) {
                if (this.center) {
                    this.$event.call("openLoading");
                    this.$api.editCenter(this.center._id, this.getCenter(), (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            if (this.onChange) this.onChange();
                            this.close();
                        }
                    });
                } else {
                    this.$event.call("openLoading");
                    this.$api.addCenter(this.name, this.phone, this.regions, this.description, (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            if (this.onChange) this.onChange();
                            this.close();
                        }
                    });
                }
            }
        },
        deleteCenter()
        {
            this.$event.call("openPopup", this.center.name + " 센터를 삭제하시겠습니까?", "", () => {
                this.$event.call("openLoading");
                this.$api.editCenter(this.center._id, { isTerminated: true }, (resData) => {
                this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        if (this.onChange) this.onChange();
                        this.close();
                    }
                });
            });
        },
        checkValidate() {
            this.$validator.clear();
            this.$validator.checkEmpty("name", this.name);
            // this.$validator.setError("region", Object.keys(this.regions).length > 0 ? "" : "지역을 추가하세요");
            this.$forceUpdate();
            return this.$validator.isAllValidate();
        },
        onRegionChange() {
            const inputValue = $("input[name=region]").attr("value");
            if (inputValue) {
                const region1Array = inputValue.split(',');
                this.regions = {};
                for (var region1 of region1Array) {
                    this.regions[region1] = [];
                }
            } else {
                this.regions = {};
            }
            this.checkValidate();
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        region1Options: function() { return this.$store.getters.region1Options; },
        region2Options: function() { return this.$store.getters.region2Options; },
        centers: {
            get: function() { return this.$store.getters.centers; },
            set: function(val) { return this.$store.commit("setCenters", val); },
        },
    },
    watch: {
        name: function(val) { this.name = this.$validator.replaceAlphaKorNum(val); this.checkValidate(); },
        phone: function(val) { this.phone = this.$validator.replaceNumDashBracket(val); },
        password: function(val) { this.password = this.$validator.replaceAlphaKorNum(val); },
    }
}
</script>

<style>

#center_detail_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#center_detail_modal .column {
    max-width: 800px;
}

#center_detail_modal #header {
    padding: 20px 30px;
}

#center_detail_modal #body {
    padding: 0;
}

#center_detail_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#center_detail_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/CenterModal_Edit.vue